import {
    GET_WIDGET,
    SET_WIDGET,
    API_ERROR,
    GET_WIDGETS,
    SET_WIDGETS,
    RESET_WIDGETS,
    UNMOUNT_WIDGET,
  } from "./actionTypes";

  const initialState = {
    error: false,
    loading: false,
    widgets: [],
    conversations: {},
    success: false,
  };
  
  const Tab = (state = initialState, action) => {
    switch (action.type) {
      case GET_WIDGETS:
        state = {
          ...state,
          error: false,
          loading: true,
          widgets: [],
        };
        break;
      case SET_WIDGETS:
        state = {
          ...state,
          error: false,
          loading: false,
          widgets: action.payload.data.widgets,
        };
        break;
      case GET_WIDGET:
        state = {
          ...state,
          error: false,
          loading: true,
          conversations: {
            ...state.conversations,
            [action.payload.chatId]: {},
          },
        };
        break;
      case SET_WIDGET:
        state = {
          ...state,
          error: false,
          loading: false,
          conversations: {
              ...state.conversations,
                [action.payload.chatId]: {
                    ...state.conversations[action.payload.chatId],
                    [action.payload.widgetId] : {
                      chatId: action.payload.chatId,
                      widgetId: action.payload.widgetId,
                      data: action.payload.data,
                    }
                },
            },
        };
        break;
      case UNMOUNT_WIDGET:
        state = {
          ...state,
          conversations: {
            ...state.conversations,
            [action.payload.chatId]: {
              ...state.conversations[action.payload.chatId],
              [action.payload.widgetId]: {
                ...state.conversations[action.payload.chatId][action.payload.widgetId],
                unMounted: action.payload.unMounted,
              },
            },
          },
        };
        break;
      case API_ERROR:
        state = {
          ...state,
          error: action.payload,
          loading: false,
          loadingDelete: false,
          success: false,
        };
        break;
      case RESET_WIDGETS:
        state = {
          ...state,
          error: false,
          loading: false,
          success: false,
          conversations: {},
        };
        break;
      default:
          state = { ...state, error: false, loading: false };
        break;
    }
    return state;
  };
  
  export default Tab;
  